import { render } from "./ActiveBar.vue?vue&type=template&id=fadcbdca&scoped=true"
import script from "./ActiveBar.vue?vue&type=script&lang=js"
export * from "./ActiveBar.vue?vue&type=script&lang=js"

import "./ActiveBar.vue?vue&type=style&index=0&id=fadcbdca&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fadcbdca"]])

export default __exports__